
export default class DefaultAircraft {
    "aircraft": string = "";
    "fleetCode": string = "";
    "fleetDescription": string = "";
    "configurationCode": string = "";
    "configurationDescription": string = "";
    "premiumLevel": number;
} 